import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  Badge,
} from 'react-bootstrap';
import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Divider, Spin, Checkbox, Tag, Tooltip } from "antd";
import CurrencyInput from 'react-currency-input-field';

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
// import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../v5/utils/store.tsx';
import slice, { useFormikContext, fields, BinActivity, jobBinTypesInit, findStatus, checkStatus } from '../slice.tsx';
import servicesSlice from './services/slice.tsx';
import billingJobSlice, { fields as fieldsBilling, ServiceType, initPricingsItem } from './billingJob/slice.tsx';

import weightChitSlice, { getKgTons, getUomDecimal } from './weightChit/slice.tsx';

import { fields as jobTypeFields, getCustomerSiteIdFromSelectedBin, getFirstCustomerSite, isAllCustomerSiteSelected, LocalJobType, LocalBinActivity, ForWith, LocationEnum, isTaskType } from '../../manage/jobs/jobTypes/slice.tsx';

// enums
import { warning, isNumeric, getMaxPageSize, getDefaultUOMv4, hasPermission } from '../../../../v5/utils/utils.tsx';
import { Permissions } from '../../../../v5/utils/enums.tsx';

// components
import SmartSelect from '../../../../v5/components/select/SmartSelect.tsx';
import SmartAutocomplete from '../../../../v5/components/autocomplete/SmartAutocomplete.tsx';

import { ReactComponent as PlusIcon } from "../../../../v5/assets/icons/plus.svg";
import { ReactComponent as MinusIcon } from "../../../../v5/assets/icons/minus.svg";
import { ReactComponent as TrashIcon } from "../../../../v5/assets/icons/trash.svg";
import { ReactComponent as CheckIcon } from "../../../../v5/assets/icons/check.svg";
import { ReactComponent as SettingsIcon } from "../../../../v5/assets/icons/settings.svg";

// ----------------------------------------------------------------------

const StyledCard: React.FC<React.ComponentProps<typeof Card>> = styled(Card)`
  padding: 8px 16px 16px 16px;
`;

const StyledTable = styled.table`
  width: 100%;

  thead {
    tr {
      th {
        background-color: var(--bs-blue-focus1) !important;
      }
    }
  }
  
  tbody {
    tr {
      vertical-align: top;
    }
  }
`;


const BinDetails = (props: any) => {
  // const location = useLocation();
  // const router = useRouter();

  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  // const { isLoading } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();


  const getServiceList = ({ group, g }: any) => {
    return <Col xs={12} className={((group?.type === LocalJobType.EXCHANGE1 || group?.type === LocalJobType.EXCHANGE2 || group?.type === LocalJobType.DISPOSAL || group?.type === LocalJobType.ON_THE_SPOT || group?.type === LocalJobType.TIPPER || group?.type === LocalJobType.TASK) ? 'mt-12' : '')}>
      <Row className='g-12 align-items-center'>
        {(group?.type === LocalJobType.DROP || group?.type === LocalJobType.PICK || group?.type === LocalJobType.SHIFT) && <Col xs={12} className='mt-0'><Divider className='mt-0' /></Col>}

        <Col xs={12} className='semibold gray-900'>Service</Col>

        <Col xs={12}>
          <StyledTable>
            <thead>
              <tr>
                <th style={{ width: '80%' }}>{fieldsBilling.serviceTag.label}</th>
                <th style={{ width: '15%' }}>{fieldsBilling.quantity.label}</th>
                <th style={{ width: '5%' }}>{fieldsBilling.delete.label}</th>
              </tr>
            </thead>
            <tbody>

              {(values.pricings && values.pricings.length > 0) && values.pricings.map((item: any, i: number) => {
                return <tr key={'jobform_additional_services_' + i}
                  className={(((item.serviceType === ServiceType.AdditionalService) && !(item.bundleServiceTag != null && item.bundleServiceTag != '')) ? 'd-table-row' : 'd-none')}
                >
                  <td>
                    <Form.Group>
                      <Form.Control
                        as={SmartSelect}
                        isInvalid={!!(errors && errors.pricings && errors.pricings[i] && errors.pricings[i].serviceTag)}
                        value={item.serviceItemId}
                        placeholder={fieldsBilling.serviceTag.placeholder}

                        addText={'Add new service item'}
                        apiPath={'service-item'}
                        customParams={{
                          type: ServiceType.AdditionalService,
                          customerId: values?.customerId,
                          customerSiteId: getCustomerSiteIdFromSelectedBin(group)?.customerSiteId1,
                          includeGlobalService: true,
                          IncludeTaxRate: true,
                          sortColumn: 'serviceTag',
                          sortDir: 'desc'
                        }}
                        fieldNames={{ value: 'serviceItemId', label: 'serviceTag' }}
                        selected={{ serviceItemId: item.serviceItemId, serviceTag: item.serviceTag }}
                        getPopupContainer={(trigger: any) => trigger.parentNode}

                        hasOptionRender={false}
                        hasFooterRender={false}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                        virtual={true}

                        onChangeValue={async (value: any, option: any, ref: any) => {
                          if(option){
                            await setFieldValue('pricings.' + i + '.serviceItemId', value);
                            await setFieldValue('pricings.' + i + '.serviceTag', option.serviceTag);
                            await setFieldValue('pricings.' + i + '.serviceItem', option);

                            let chargeCategory = (option && option.chargeCategory) ? option.chargeCategory : null;
                            let chargeCategoryId = (chargeCategory && chargeCategory.chargeCategoryId) ? chargeCategory.chargeCategoryId : null;
                            let chargeCategoryName = (chargeCategory && chargeCategory.chargeCategoryName) ? chargeCategory.chargeCategoryName : '';

                            if (chargeCategory) {
                              await setFieldValue('pricings.' + i + '.chargeCategoryId', chargeCategoryId);
                              await setFieldValue('pricings.' + i + '.chargeCategoryName', chargeCategoryName);
                              await setFieldValue('pricings.' + i + '.chargeCategory', chargeCategory);
                            }


                            let billingType = option ? option.billingType : null;
                            if(billingType){
                              await setFieldValue('pricings.' + i + '.billingType', billingType);
                            }
                            
                            let price = option ? option.price : '0';
                            await setFieldValue('pricings.' + i + '.price', price);
                            await setFieldValue('pricings.' + i + '.quantity', 1);
                            await setFieldValue('pricings.' + i + '.bundleServiceTag', '');
                          } else {
                            await setFieldValue('pricings.' + i + '.serviceItemId', null);
                            await setFieldValue('pricings.' + i + '.serviceTag', '');
                            await setFieldValue('pricings.' + i + '.serviceItem', null);

                            await setFieldValue('pricings.' + i + '.bundleServiceTag', '');
                            await setFieldValue('pricings.' + i + '.billingType', null);

                            await setFieldValue('pricings.' + i + '.price', '');
                            await setFieldValue('pricings.' + i + '.quantity', '');

                            await setFieldValue('pricings.' + i + '.chargeCategoryId', null);
                            await setFieldValue('pricings.' + i + '.chargeCategoryName', '');
                            await setFieldValue('pricings.' + i + '.chargeCategory', null);
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">{(errors && errors.pricings && errors.pricings[i] && errors.pricings[i].serviceTag) && errors.pricings[i].serviceTag}</Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid" className={'d-block'}>{(errors && errors.pricings && errors.pricings[i] && errors.pricings[i].quantity) && errors.pricings[i].quantity}</Form.Control.Feedback>
                    </Form.Group>
                  </td>
                  <td>
                    <Form.Group className='plus-minus-button-start'>
                      <InputGroup>
                        <Form.Control
                          className='custom'
                          as={CurrencyInput}
                          allowDecimals={true}
                          allowNegativeValue={false}
                          decimalsLimit={2}

                          disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                          autoComplete='off'
                          placeholder={fieldsBilling.quantity.placeholder}
                          value={item?.quantity}
                          onValueChange={async (value: any) => {
                            await setFieldValue('pricings.' + i + '.quantity', value);
                          }}
                          onBlur={async () => {
                            let numb = isNumeric(item?.quantity) ? parseInt(item?.quantity) : 0;

                            if(numb < 1){
                              await setFieldValue('pricings.' + i + '.quantity', 1);
                            }
                          }}
                        
                          isInvalid={!!(errors && errors.pricings && errors.pricings[i] && errors.pricings[i].quantity)}
                        />
                        <InputGroup.Text>
                          <span
                            onClick={async () => {
                              if((item.useBinWeightQuantity == false)){
                                let minNumb = 1;
                                let numb = isNumeric(item?.quantity) ? parseInt(item?.quantity) : 1;

                                if(numb > minNumb){
                                  await setFieldValue('pricings.' + i + '.quantity', (numb-1).toString());
                                }
                              }
                            }}
                          >
                            <MinusIcon />
                          </span>
                          <span
                            onClick={async () => {
                              if((item.useBinWeightQuantity == false)){
                                let numb = isNumeric(item?.quantity) ? parseInt(item?.quantity) : 1;
                                await setFieldValue('pricings.' + i + '.quantity', (numb+1).toString());
                              }
                            }}
                          >
                            <PlusIcon />
                          </span>
                        </InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                  </td>
                  <td>
                    <Button
                      className='p-6'
                      variant={'custom-secondary-danger'}
                      disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();

                        let items = _.cloneDeep(values.pricings);
                        items.splice(i, 1);
                        setFieldValue('pricings', items);
                      }}
                    >
                      <TrashIcon style={{ width: '18px', height: '18px' }} />
                    </Button>
                  </td>
                </tr>
              })}
              
            </tbody>
          </StyledTable>
        </Col>
        <Col xs={12}>{addServiceButton()}</Col>
      </Row>
    </Col>
  }


  const getRowTask = ({
    group, g,
    block, b,
    item, i, 
  }: any) => {
    return <Col xs={12}>
      <Row className='align-items-center'>
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label disabled={false}>
              <span>Step {item?.stepOrder}: </span>
              {item?.stepDescription}
              {/* <span className='text-danger'>*</span> */}
              {/* <i className='ms-8 fs-12 regular gray-600'>(max {jobTypeFields.stepDescription.maxLength} characters)</i> */}
            </Form.Label>
            <Form.Control
              type={'text'}
              autoComplete='off'
              placeholder={jobTypeFields.stepTaskService.placeholder}
              // maxLength={jobTypeFields.stepDescription.maxLength}
              disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
              readOnly={true}
              value={item?.serviceItemName || ''}
              onChange={async (e) => {
                // await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.steps.' + i + '.stepDescription', e.target.value);
              }}
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                
                if(values.steps.some((x: any) => x.locationType === LocationEnum.CustomerSite)){
                  let customerSites = getCustomerSiteIdFromSelectedBin(group);
                  if(isNumeric(customerSites?.customerSiteId1)){
                    dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: customerSites?.customerSiteId1, groupIndex: g, group: group, blockIndex: b, block: block, index: i, serviceItem: item?.serviceItem, wasteTypes: item?.wasteTypes, isTask: true, isAdditional: false }));
                  } else {
                    warning('Warning', 'You must select a customer site');
                  }
                } else {
                  dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: null, groupIndex: g, group: group, blockIndex: b, block: block, index: i, serviceItem: item?.serviceItem, wasteTypes: item?.wasteTypes, isTask: true, isAdditional: false }));
                }
              }}
              isInvalid={!!(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].steps && errors.stepGroups[g].blocks[b].steps.length > 0 && errors.stepGroups[g].blocks[b].steps[i] &&
                typeof errors.stepGroups[g].blocks[b].steps[i] === 'object' && errors.stepGroups[g].blocks[b].steps[i].serviceItemId
              )}
            />
            <Form.Control.Feedback type="invalid">{(
              errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
              errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
              errors.stepGroups[g].blocks[b].steps && errors.stepGroups[g].blocks[b].steps.length > 0 && errors.stepGroups[g].blocks[b].steps[i] &&
              errors.stepGroups[g].blocks[b].steps[i].serviceItemId
            ) && errors.stepGroups[g].blocks[b].steps[i].serviceItemId}</Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </Col>
  }
  
  const getRow = ({
    group, g,
    block, b,
    item, i, 
    isDisabledFields
  }: any) => {
    let status1 = findStatus(values?.jobTemplate?.templateStatuses, 'in progress');
    let status2 = findStatus(values?.jobTemplate?.templateStatuses, 'completed');
    let isCompleted = ((status1 && values?.statusId === status1?.jobStatusId) || (status2 && values?.statusId === status2?.jobStatusId)) ? true : false;

    let nextBin: any = null;
    if((b === 0) && group && group.blocks && group.blocks.length > 1 && group.blocks[1]){
      if(group.blocks[1].bins && group.blocks[1].bins.length > 0 && group.blocks[1].bins[i]){
        nextBin = group.blocks[1].bins[i];
      }
    }

    return <>
      <Row className='g-12 align-items-center'>
        {(group?.type != LocalJobType.TIPPER) && <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>{fields.binTypeId.label} {i+1}</Form.Label>
            <Form.Control
              type={'text'}
              autoComplete='off'
              placeholder={fields.binTypeId.placeholder}
              disabled={isDisabledFields || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
              readOnly={true}
              value={item?.binType?.binTypeName || ''}
              onChange={async (e) => {
                
              }}
              onClick={() => {
                if(values.steps.some((x: any) => x.locationType === LocationEnum.CustomerSite)){
                  let customerSites = getCustomerSiteIdFromSelectedBin(group);
                  if(isNumeric(customerSites?.customerSiteId1)){
                    dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: customerSites?.customerSiteId1, groupIndex: g, group: group, blockIndex: b, block: block, index: i, serviceItem: item?.serviceItem, wasteTypes: item?.wasteTypes, isTask: false, isAdditional: false }));
                  } else {
                    warning('Warning', 'You must select a customer site');
                  }
                } else {
                  dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: null, groupIndex: g, group: group, blockIndex: b, block: block, index: i, serviceItem: item?.serviceItem, wasteTypes: item?.wasteTypes, isTask: false, isAdditional: false }));
                }
              }}
              isInvalid={!!(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].binTypeId
              )}
            />
            {((group?.type != LocalJobType.TIPPER) && (item?.binType?.isNoninventory == true)) && <i className='fs-11 gray-500'>Non-Inventory</i>}

            {/* <Form.Control.Feedback type="invalid">{(
              errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
              errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
              errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
              errors.stepGroups[g].blocks[b].bins[i].binTypeId
            ) && errors.stepGroups[g].blocks[b].bins[i].binTypeId}</Form.Control.Feedback> */}
          </Form.Group>
        </Col>}
        {!((group?.type === LocalJobType.DISPOSAL) && (block?.type === LocalBinActivity.DROP_EMPTY)) && <Col xs={12} md={3}>
          <Form.Group>
            {
              (block?.isForWith === ForWith.FOR)
              ?
              <Form.Label>{fields.wasteTypeId.labelFor}</Form.Label>
              :
                (block?.isForWith === ForWith.WITH)
                ?
                <Form.Label>{fields.wasteTypeId.labelWith}</Form.Label>
                :
                <Form.Label>{fields.wasteTypeId.label}</Form.Label>
            }
            <Form.Control
              type={'text'}
              autoComplete='off'
              placeholder={fields.wasteTypeId.placeholder}
              disabled={isDisabledFields || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
              readOnly={true}
              value={item?.wasteType?.wasteTypeName || ''}
              onChange={async (e) => {
                
              }}
              onClick={() => {
                if(values.steps.some((x: any) => x.locationType === LocationEnum.CustomerSite)){
                  let customerSites = getCustomerSiteIdFromSelectedBin(group);
                  if(isNumeric(customerSites?.customerSiteId1)){
                    dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: customerSites?.customerSiteId1, groupIndex: g, group: group, blockIndex: b, block: block, index: i, serviceItem: item?.serviceItem, wasteTypes: item?.wasteTypes, isTask: false, isAdditional: false }));
                  } else {
                    warning('Warning', 'You must select a customer site');
                  }
                } else {
                  dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: null, groupIndex: g, group: group, blockIndex: b, block: block, index: i, serviceItem: item?.serviceItem, wasteTypes: item?.wasteTypes, isTask: false, isAdditional: false }));
                }
              }}
              isInvalid={!!(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].wasteTypeId
              )}
            />
            {((group?.type != LocalJobType.TIPPER) && (item?.binType?.isNoninventory == true)) && <i className='fs-11 gray-500'>&nbsp;</i>}
            {/* <Form.Control.Feedback type="invalid">{(
              errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
              errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
              errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
              errors.stepGroups[g].blocks[b].bins[i].wasteTypeId
            ) && errors.stepGroups[g].blocks[b].bins[i].wasteTypeId}</Form.Control.Feedback> */}
          </Form.Group>
        </Col>}
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label disabled={true}>{fields.serviceTag.label}</Form.Label>
            <Form.Control
              type={'text'}
              autoComplete='off'
              placeholder={fields.serviceTag.placeholder}
              disabled={true}
              value={item?.serviceItem?.serviceTag || ''}
              onChange={async (e) => {
                await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.serviceTag', e.target.value);
              }}
              isInvalid={!!(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].serviceTag
              )}
            />
            {((group?.type != LocalJobType.TIPPER) && (item?.binType?.isNoninventory == true)) && <i className='fs-11 gray-500'>&nbsp;</i>}
            <Form.Control.Feedback type="invalid">{(
              errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
              errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
              errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
              errors.stepGroups[g].blocks[b].bins[i].serviceTag
            ) && errors.stepGroups[g].blocks[b].bins[i].serviceTag}</Form.Control.Feedback>
          </Form.Group>
        </Col>
        
        {(group?.type != LocalJobType.TIPPER) && <>
          <Col xs={12} md={3}>
            <Row className='g-12 align-items-center'>
              {(group?.type != LocalJobType.TIPPER) && <>
                {
                  (item?.binType?.isNoninventory === undefined || item?.binType?.isNoninventory === null)
                  ?
                  <Col xs={12} md={true}>&nbsp;</Col>
                  :
                  (item?.binType?.isNoninventory === false)
                  ?
                  <Col xs={12} md={true}>
                    <Form.Group>
                      <Form.Label>{fields.binNumberId.label}</Form.Label>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={item?.binNumber}
                        placeholder={fields.binNumberId.placeholder}
                        getPopupContainer={(trigger: any) => trigger.parentNode}

                        addText={'Add new bin number'}
                        apiPath={'binNumber'}
                        customParams={{
                          currentPage: 1,
                          pageSize: getMaxPageSize(),
                          customerId: values.customerId,
                          customerSiteId: getCustomerSiteIdFromSelectedBin(group)?.customerSiteId1,
                          binTypeId: item?.binType?.binTypeId,
                          showRecentJob: true,
                        }}
                        fieldNames={{ value: 'binNumberId', label: 'binNumberName' }}
                        selected={{ binNumberId: item?.binNumberId, binNumberName: item?.binNumber }}

                        hasOptionRender={false}
                        hasFooterRender={false}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        disabled={isDisabledFields || !(item?.binType?.binTypeId) || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                        virtual={true}

                        onChangeValue={async (value: any, option: any, ref: any) => {
                          if(option){
                            await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.binNumberId', value);
                            await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.binNumber', option.binNumberName);
                          } else {
                            await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.binNumberId', null);
                            await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.binNumber', value);
                          }
                        }}
                        
                        isInvalid={!!(
                          errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                          errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                          errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                          typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].binNumberId
                        )}
                      />
                      <Form.Control.Feedback type="invalid">{(
                        errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                        errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                        errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                        errors.stepGroups[g].blocks[b].bins[i].binNumberId
                      ) && errors.stepGroups[g].blocks[b].bins[i].binNumberId}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  :
                  <Col xs={12} md={true}>
                    <Form.Group className='plus-minus-button-start'>
                      <Form.Label>{fields.quantity.label}</Form.Label>
                      <InputGroup>
                        <Form.Control
                          className='custom'
                          as={CurrencyInput}
                          allowDecimals={false}
                          allowNegativeValue={false}
                          decimalsLimit={0}
                          maxLength={2}

                          disabled={isDisabledFields || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                          autoComplete='off'
                          placeholder={fields.quantity.placeholder}
                          value={item?.quantity}
                          onValueChange={async (value: any) => {
                            await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.quantity', value);

                            if(props.onChangeQuantity){
                              let numVal = isNumeric(value) ? parseInt(value) : 1;
                              props.onChangeQuantity(g, b, i, item, numVal);
                            }
                          }}
                          onBlur={async () => {
                            let numb = isNumeric(item?.quantity) ? parseInt(item?.quantity) : 0;

                            if(numb < 1){
                              await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.quantity', 1);
                              
                              if(props.onChangeQuantity){
                                props.onChangeQuantity(g, b, i, item, 1);
                              }
                            } else if(numb > 99){
                              await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.quantity', 99);
                              
                              if(props.onChangeQuantity){
                                props.onChangeQuantity(g, b, i, item, 99);
                              }
                            }
                          }}
                        
                          isInvalid={!!(
                            errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                            errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                            errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                            typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].quantity
                          )}
                        />
                        <InputGroup.Text>
                          <span
                            onClick={async () => {
                              const minNumb = 1;
                              let numb = isNumeric(item?.quantity) ? parseInt(item?.quantity) : 1;

                              if(numb > minNumb){
                                await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.quantity', (numb-1).toString());
                                
                                if(props.onChangeQuantity){
                                  props.onChangeQuantity(g, b, i, item, (numb-1));
                                }
                              }
                            }}
                          >
                            <MinusIcon />
                          </span>
                          <span
                            onClick={async () => {
                              const maxNumb = 99;
                              let numb = isNumeric(item?.quantity) ? parseInt(item?.quantity) : 1;

                              if(numb < maxNumb){
                                await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.quantity', (numb+1).toString());
                                
                                if(props.onChangeQuantity){
                                  props.onChangeQuantity(g, b, i, item, (numb+1));
                                }
                              }
                            }}
                          >
                            <PlusIcon />
                          </span>
                        </InputGroup.Text>
                      </InputGroup>
                      {((group?.type != LocalJobType.TIPPER) && (item?.binType?.isNoninventory == true)) && <i className='fs-11 gray-500'>&nbsp;</i>}
                      <Form.Control.Feedback type="invalid">{(
                        errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                        errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                        errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                        errors.stepGroups[g].blocks[b].bins[i].quantity
                      ) && errors.stepGroups[g].blocks[b].bins[i].quantity}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                }
              </>}

              {((i > 0) && (isDisabledFields == false)) && <Col xs={12} md={'auto'} className='text-center text-md-start'>
                <Form.Group>
                  <Form.Label className='d-block'>&nbsp;</Form.Label>
                  <Button
                    className='p-6'
                    variant={'custom-secondary-danger'}
                    disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      e.preventDefault();

                      let groupsArr = _.cloneDeep(values.stepGroups);
                      let binsArr = groupsArr[g]?.blocks[b]?.bins || [];
                      binsArr.splice(i, 1);

                      setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins', binsArr);

                      if(group?.type === LocalJobType.EXCHANGE1){
                        if((block?.isForWith === ForWith.FOR)){
                          let binsArrFor = groupsArr[g]?.blocks[(b+1)]?.bins || [];
                          binsArrFor.splice(i, 1);

                          setFieldValue('stepGroups.' + g + '.blocks.' + (b+1) + '.bins', binsArrFor);
                        } else {
                          let binsArrWith = groupsArr[g]?.blocks[(b-1)]?.bins || [];
                          binsArrWith.splice(i, 1);

                          setFieldValue('stepGroups.' + g + '.blocks.' + (b-1) + '.bins', binsArrWith);
                        }
                      }

                      if(props.onRemoveBin){
                        props.onRemoveBin(g, b, i, item);
                      }
                    }}
                  >
                    <TrashIcon style={{ width: '18px', height: '18px' }} />
                  </Button>
                  {((group?.type != LocalJobType.TIPPER) && (item?.binType?.isNoninventory == true)) && <div>&nbsp;</div>}
                </Form.Group>
              </Col>}
            </Row>
          </Col>
        </>}
        
        {(block?.isForWith === ForWith.WITH) && <>
          {(group?.type === LocalJobType.DISPOSAL || (group?.type === LocalJobType.TIPPER && b === 0)) && <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>{fields.binOutWeight.label}</Form.Label>
              <InputGroup>
                <Form.Control
                    as={CurrencyInput}
                    allowDecimals={(getUomDecimal() === 0) ? false : true}
                    allowNegativeValue={false}
                    decimalsLimit={getUomDecimal()}
                    // suffix={' ' + getKgTons(getDefaultUOMv4(), '', '')}

                    autoComplete='off'
                    placeholder={fields.binOutWeight.placeholder}
                    readOnly={false}
                    disabled={((group?.type !== LocalJobType.TIPPER) ? !(item?.binTypeId > 0) : !(item?.wasteTypeId > 0)) || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                    value={item?.binOutWeight}
                    onValueChange={async (value: any) => {
                      await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.binOutWeight', value);
                    }}
                    isInvalid={!!(
                      errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                      errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                      errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                      typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].binOutWeight
                    )}
                />
                <InputGroup.Text>{getKgTons(getDefaultUOMv4(), '', '')}</InputGroup.Text>
              </InputGroup>
              <Form.Control.Feedback type="invalid">{(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                errors.stepGroups[g].blocks[b].bins[i].binOutWeight
              ) && errors.stepGroups[g].blocks[b].bins[i].binOutWeight}</Form.Control.Feedback>
            </Form.Group>
          </Col>}

          {((group?.type !== LocalJobType.TIPPER) || ((group?.type === LocalJobType.TIPPER && b > 0))) && <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>{(group?.type === LocalJobType.DISPOSAL || (group?.type === LocalJobType.TIPPER && b > 0)) ? fields.binWeight.labelDisposal : fields.binWeight.label}</Form.Label>
              <InputGroup>
                <Form.Control
                    as={CurrencyInput}
                    allowDecimals={false}
                    allowNegativeValue={false}
                    decimalsLimit={0}
                    // suffix={' ' + getKgTons(getDefaultUOMv4(), '', '')}

                    autoComplete='off'
                    placeholder={fields.binWeight.placeholder}
                    readOnly={true}
                    disabled={((group?.type !== LocalJobType.TIPPER) ? !(item?.binTypeId > 0) : !(item?.wasteTypeId > 0)) || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                    value={item?.binWeight}
                    onValueChange={async (value: any) => {
                      // await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.binWeight', value);
                    }}
                    isInvalid={!!(
                      errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                      errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                      errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                      typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].binWeight
                    )}

                    onClick={() => {
                      if(group?.type !== LocalJobType.TIPPER){
                        if((item?.binTypeId > 0)){
                          dispatch(weightChitSlice.setShow({ show: true, details: values }));
                        }
                      } else {
                        if((item?.wasteTypeId > 0)){
                          dispatch(weightChitSlice.setShow({ show: true, details: values }));
                        }
                      }
                    }}
                />
                <InputGroup.Text>{getKgTons(getDefaultUOMv4(), '', '')}</InputGroup.Text>
              </InputGroup>
              <Form.Control.Feedback type="invalid">{(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                errors.stepGroups[g].blocks[b].bins[i].binWeight
              ) && errors.stepGroups[g].blocks[b].bins[i].binWeight}</Form.Control.Feedback>
            </Form.Group>
          </Col>}

          {(isCompleted && (group?.type != LocalJobType.DISPOSAL) && (group?.type != LocalJobType.TIPPER)) && <Col xs={12} md={true}>
            <Form.Group>
              <Form.Label>{fields.additionalWaste.label}</Form.Label>
              <Form.Control
                as={SmartSelect}
                value={item?.wasteTypes?.filter((x: any) => x?.wasteTypeId != item?.wasteTypeId)?.map((x: any) => x?.wasteTypeId)}
                placeholder={fields.additionalWaste.placeholder}

                addText={'Add new waste type'}
                apiPath={'wasteType'}
                customParams={{
                  // customerId: values?.customerId,
                  customerSiteId: getCustomerSiteIdFromSelectedBin(group)?.customerSiteId1,
                  binTypeId: item?.binTypeId,
                  currentPage: 1,
                  pageSize: getMaxPageSize(),
                }}
                readResponseFunc={(options: any) => {
                  let data = (options && options.data && options.data.length > 0) ? options.data : [];

                  let arr: Array<any> = [];
                  if(data && data.length > 0){
                    data.forEach((x: any) => {
                      if(item?.wasteTypeId != x?.wasteTypeId){
                        arr.push({
                          ...x,
                          wasteType: x,
                          disabled: (item?.wasteTypeId === x?.wasteTypeId) ? true: false,
                        });
                      }
                    });
                  }

                  return arr;
                }}

                fieldNames={{ value: 'wasteTypeId', label: 'wasteTypeName' }}
                selected={{
                  wasteTypeId: item?.wasteTypes?.filter((x: any) => x?.wasteTypeId != item?.wasteTypeId)?.map((x: any) => x?.wasteTypeId), 
                  wasteTypeName: item?.wasteTypes?.filter((x: any) => x?.wasteTypeId != item?.wasteTypeId)?.map((x: any) => x?.wasteType?.wasteTypeName),
                  disabled: item?.wasteTypes?.filter((x: any) => x?.wasteTypeId != item?.wasteTypeId)?.map((x: any) => (item?.wasteTypeId === x?.wasteTypeId) ? true: false)
                }}
                getPopupContainer={(trigger: any) => trigger.parentNode}

                mode="multiple"
                maxTagCount={'responsive'}
                hasOptionRender={true}
                hasFooterRender={false}
                searchable={true}
                allowClear={false}
                selectedIcon={false}
                disabled={!(item?.binTypeId > 0) || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
                virtual={true}

                customDisplayTags={(isLoading: any, ref: any) => {
                  return <Row className={'align-items-center gx-0 gy-6'}>
                    <Col xs={'auto'}>
                      <Tag
                        color="processing"
                        closeIcon={false}
                      >{item?.wasteType?.wasteTypeName}</Tag>
                    </Col>
                    
                    {(item && item.wasteTypes && item.wasteTypes.length > 0) && item.wasteTypes.map((x: any, ind: number) => {
                      if(item?.wasteTypeId != x?.wasteTypeId){
                        return <Col xs={'auto'} key={'jobform_bindetails_additionalwaste_item_' + ind}>
                          <Tag
                            color="processing"
                            closeIcon={true}
                            onClose={(e: any) => {
                              e.stopPropagation();
                              e.preventDefault();
                              
                              const wasteTypes = (item && item.wasteTypes && item.wasteTypes.length > 0) ? [...item.wasteTypes] : [];
                              wasteTypes.splice(ind, 1);
                              
                              setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.wasteTypes', wasteTypes);

                              if(props.onChangeWasteTypes){
                                const unchanged = item.wasteTypes.filter((y: any) => y?.wasteTypeId !== x?.wasteTypeId);
                                props.onChangeWasteTypes(g, b, i, item, [x], [], unchanged);
                              }
                            }}
                          >{x?.wasteType?.wasteTypeName}</Tag>
                        </Col>
                      }
                    })}
                  </Row>
                }}
                optionRender={(option: any, ref: any) => {
                  if(option && option.label && option.label != undefined){
                    let isSelected = item?.wasteTypes?.findIndex((x: any) => x?.wasteTypeId === option?.data?.wasteTypeId) > -1 ? true : false;

                    return <Row className={'align-items-center gx-2'}>
                      <Col xs={true}>{option?.data?.wasteTypeName}</Col>

                      {isSelected && <Col xs={'auto'}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <Row className={'align-items-center gx-2'}>
                          {(!isNumeric(option?.data?.serviceItemId)) && <>
                            <Col xs={'auto'}>
                              <Tooltip overlayClassName='dark' title={'Billing item is missing'}>
                                <Badge bg={'custom-border-warning'}>Attention</Badge>
                              </Tooltip>
                            </Col>
                            {(hasPermission(Permissions.JobBilling)) && <Col xs={'auto'}>
                              <Button
                                variant={'custom-none-primary'}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  
                                  dispatch(billingJobSlice.setShow({ show: true, form: values }));
                                }}
                              ><SettingsIcon /></Button>
                            </Col>}
                          </>}
                          <Col xs={'auto'}><CheckIcon /></Col>
                        </Row>
                      </Col>}
                    </Row>
                  } else {
                    return null
                  }
                }}
                onChangeValue={async (value: any, option: any, ref: any) => {
                  if(option){
                    await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.wasteTypes', option);
                    
                    if(props.onChangeWasteTypes){
                      const wasteTypes = (item && item.wasteTypes && item.wasteTypes.length > 0) ? item.wasteTypes.filter((x: any) => x?.wasteTypeId != item?.wasteTypeId) : [];
                      const newServiceItemIds = (option && option.length > 0) ? option : [];

                      const added = newServiceItemIds.filter((x: any) => !wasteTypes.some((y: any) => y?.wasteTypeId === x?.wasteTypeId));
                      const removed = wasteTypes.filter((x: any) => !newServiceItemIds.some((y: any) => y?.wasteTypeId === x?.wasteTypeId));
                      const unchanged = newServiceItemIds.filter((x: any) => wasteTypes.some((y: any) => y?.wasteTypeId === x?.wasteTypeId));

                      props.onChangeWasteTypes(g, b, i, item, removed, added, unchanged);
                    }
                  } else {
                    await setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins.' + i + '.wasteTypes', []);

                    if(props.onChangeWasteTypes){
                      const removedServiceItemIds = (item && item.wasteTypes && item.wasteTypes.length > 0) ? item.wasteTypes.filter((x: any) => x?.wasteTypeId != item?.wasteTypeId) : [];
                      props.onChangeWasteTypes(g, b, i, item, removedServiceItemIds, [], []);
                    }
                  }
                }}

                isInvalid={!!(
                  errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                  errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                  errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                  typeof errors.stepGroups[g].blocks[b].bins[i] === 'object' && errors.stepGroups[g].blocks[b].bins[i].wasteTypes
                )}
              />
              <Form.Control.Feedback type="invalid">{(
                errors && errors.stepGroups && errors.stepGroups.length > 0 && errors.stepGroups[g] && 
                errors.stepGroups[g].blocks && errors.stepGroups[g].blocks.length > 0 && errors.stepGroups[g].blocks[b] &&
                errors.stepGroups[g].blocks[b].bins && errors.stepGroups[g].blocks[b].bins.length > 0 && errors.stepGroups[g].blocks[b].bins[i] &&
                errors.stepGroups[g].blocks[b].bins[i].wasteTypes
              ) && errors.stepGroups[g].blocks[b].bins[i].wasteTypes}</Form.Control.Feedback>
            </Form.Group>
          </Col>}
        </>}

        {((group?.type === LocalJobType.EXCHANGE1) && (block?.isForWith === ForWith.FOR)) && <>
          <Col xs={12}>
            <Checkbox
              disabled={!(item?.binType?.binTypeId) || checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
              checked={(item?.binType?.binTypeId && item?.serviceItemId === nextBin?.serviceItemId) ? true : false}
              onChange={async (e: any) => {
                if(e.target.checked && isNumeric(item.serviceItemId)){
                  dispatch(servicesSlice.callDetailsServicesItemsApi([item.serviceItemId], (state: boolean, selectedServices: any) => {
                    if(state){
                      let arr = selectedServices.map((y: any) => {
                        return {
                          ...y,
                          binTypeName: y?.binType?.binTypeName,
                          wasteTypeName: y?.wasteType?.wasteTypeName,
                        }
                      });
            
                      let mainData = arr.find((x: any) => x.serviceItemId == item?.serviceItemId);
                      let anotherData = arr.filter((x: any) => x.serviceItemId != mainData.serviceItemId);
            
                      if(props.onCopyToBelowSection){
                        mainData['binNumberId'] = item?.binNumberId;
                        mainData['binNumber'] = item?.binNumber;
                        mainData['quantity'] = item?.quantity;
                        mainData['isNoninventory'] = item?.isNoninventory;

                        props.onCopyToBelowSection(g, (b+1), i, mainData, anotherData, item);
                      }
                    }
                  }));
                } else {
                  props.onCopyToBelowSection(g, (b+1), i, null);
                }
              }}
            >Copy to below section</Checkbox>
          </Col>
        </>}

      </Row>
    </>
  }


  const getBinElements = () => {
    let shouldShowAddServiceButton = ((values.pricings && values.pricings.length > 0) && values.pricings.filter((x: any) => (x.serviceType === ServiceType.AdditionalService) && !(x.bundleServiceTag != null && x.bundleServiceTag != '')).length > 0) ? true : false;
    
    if(values.stepGroups && values.stepGroups.length > 0){
      return <Row className='g-24 align-items-center'>

        {values.stepGroups.map((group: any, g: number) => {
          return <Col xs={12} key={'jobform_bindetails_group_' + g}>

            {
            (group && group.blocks && group.blocks.length > 0)
            ?
            group.blocks.map((block: any, b: number) => {
              let isDisabledFields = (block && block.bins) ? false : true;
              let prevBlock = (b > 0) ? group.blocks[(b-1)] : [];

              let prevBins = (prevBlock && prevBlock.bins && prevBlock.bins.length > 0) ? prevBlock.bins : [];
              let currentBins = (block && block.bins && block.bins.length > 0) ? block.bins : [];

              let binsArray = isDisabledFields ? prevBins : currentBins;

              if(block.type != null){
                return <StyledCard className={'no-bg ' + ((b > 0) ? 'mt-12' : '')} key={'jobform_bindetails_group_' + g + '_block_' + b}>
                  <Row className='g-12 align-items-center'>
                    <Col xs={12} className='semibold gray-900'>{block?.title}</Col>
      
                    {(binsArray && binsArray.length > 0) && binsArray.map((item: any, i: number) => {
                      return <Col xs={12} key={'jobform_bindetails_group_' + g + '_block_' + b + '_bin_' + i}>
                        <Row className='g-12 align-items-start'>
                          <Col xs={12} md={true}>
                            {getRow({
                              group: group, g: g,
                              block: block, b: b,
                              item: item, i: i, 
                              isDisabledFields: isDisabledFields
                            })}
                          </Col>

                          {(group?.type === LocalJobType.DROP || group?.type === LocalJobType.PICK || group?.type === LocalJobType.SHIFT) && <Divider className='mt-16 mb-s4' />}
                          {((i < (binsArray.length-1)) && (group?.type === LocalJobType.EXCHANGE1 || group?.type === LocalJobType.EXCHANGE2 || group?.type === LocalJobType.DISPOSAL || group?.type === LocalJobType.ON_THE_SPOT)) && <Divider className='mt-16 mb-s4' />}
                        </Row>
                      </Col>
                    })}
      
                    {(group?.type === LocalJobType.DROP || group?.type === LocalJobType.PICK || group?.type === LocalJobType.SHIFT) && <Col xs={12}>
                      <Row className='gx-12 align-items-center'>
                        <Col xs={'auto'}>{addButton(() => {
                          let binsArr = (values && values?.stepGroups && values?.stepGroups?.[g] && values?.stepGroups?.[g]?.blocks && values?.stepGroups?.[g]?.blocks?.[b] && values?.stepGroups?.[g]?.blocks?.[b]?.bins && values?.stepGroups?.[g]?.blocks?.[b]?.bins.length > 0) ? values?.stepGroups?.[g]?.blocks?.[b]?.bins : [];
                          const isInvalid = binsArr.some((itm: any) =>
                            !itm.binTypeId || itm.binTypeId === '0' ||
                            !itm.wasteTypeId || itm.wasteTypeId === '0'
                          );

                          if (isInvalid) {
                            warning('Warning', 'You must fill in the required fields');
                          } else {
                            let groupsArr = _.cloneDeep(values.stepGroups);
                            let binsArr = groupsArr[g]?.blocks[b]?.bins || [];
                            let itm = _.cloneDeep(jobBinTypesInit);
                            let binItm = (binsArr && binsArr.length > 0) ? binsArr[0] : null;
                            if(binItm){
                              itm.binActivity = binItm?.binActivity;
                            }
                            binsArr.push(itm);
                            setFieldValue('stepGroups.' + g + '.blocks.' + b + '.bins', binsArr);
                          }
                        })}</Col>
                        {!shouldShowAddServiceButton && <Col xs={true}>{addServiceButton()}</Col>}
                      </Row>
                    </Col>}
                  </Row>

                  {shouldShowAddServiceButton && (group?.type === LocalJobType.DROP || group?.type === LocalJobType.PICK || group?.type === LocalJobType.SHIFT) &&<Row className='gx-12 align-items-center'>
                    <Col xs={12} className='mt-8'>{getServiceList({ group: group, g: g })}</Col>
                  </Row>}
                </StyledCard>
              } else {
                if(group?.type === LocalJobType.TASK){
                  return <>
                    {(block && block.steps && block.steps.length > 0)
                    ?
                    <Row className='gx-32 gy-16 align-items-center'>
                      {block?.steps.map((item: any, i: number) => {
                        return getRowTask({
                          group: group, g: g,
                          block: block, b: b,
                          item: item, i: i, 
                        })
                      })}
                    </Row>
                    :
                    <span className='gray-700'>No tasks</span>}

                    <Row className='gx-12 align-items-center'>
                      {!shouldShowAddServiceButton && <Col xs={12} className='mt-8'>{addServiceButton()}</Col>}
                      {shouldShowAddServiceButton && <Col xs={12} className='mt-8'>{getServiceList({ group: group, g: g })}</Col>}
                    </Row>
                  </>
                } else {
                  return <span className='gray-700'>No bin involved</span>
                }
              }
            })
            :
            <span className='gray-700'>No bin involved</span>
            }

            {(group?.type === LocalJobType.EXCHANGE1 || group?.type === LocalJobType.EXCHANGE2 || group?.type === LocalJobType.DISPOSAL || group?.type === LocalJobType.ON_THE_SPOT) && <Row className='gx-12 align-items-center'>
              <Col xs={'auto'} className='mt-8'>{addButton(() => {
                let isInvalid = false;
                let blockArr = (values && values?.stepGroups && values?.stepGroups?.[g] && values?.stepGroups?.[g]?.blocks && values?.stepGroups?.[g]?.blocks.length > 0) ? values?.stepGroups?.[g]?.blocks : [];
                if(blockArr && blockArr.length > 0){
                  for(let bi = 0; bi < blockArr.length; bi++){
                    let bItm = blockArr[bi];
                    if(bItm && bItm.bins && bItm.bins.length > 0){
                      isInvalid = bItm.bins.some((itm: any) =>
                        !itm.binTypeId || itm.binTypeId === '0' ||
                        !itm.wasteTypeId || itm.wasteTypeId === '0'
                      );

                      if(isInvalid){
                        break;
                      }
                    }
                  }
                }

                if (isInvalid) {
                  warning('Warning', 'You must fill in the required fields');
                } else {
                  let groupsArr = _.cloneDeep(values.stepGroups);
                  let blocksArr = groupsArr[g]?.blocks || [];
    
                  blocksArr.forEach((blck: any, bInd: number) => {
                    if(blck.bins){
                      let itm = _.cloneDeep(jobBinTypesInit);
                      let binItm = (blck && blck.bins && blck.bins.length > 0) ? blck.bins[0] : null;
                      if(binItm){
                        itm.binActivity = binItm?.binActivity;
                      }
                      blck.bins.push(itm);
                    }
                  })
    
                  setFieldValue('stepGroups.' + g + '.blocks', blocksArr);
    
                  if(group?.type === LocalJobType.EXCHANGE1){
                    if(props.onAddNew){
                      props.onAddNew(g, (blocksArr.length-1));
                    }
                  }
                }
              })}</Col>
              {!shouldShowAddServiceButton && <Col xs={true} className='mt-8'>{addServiceButton()}</Col>}
            </Row>}

            {(!shouldShowAddServiceButton  && (group?.type === LocalJobType.TIPPER)) && <Row className='gx-12 align-items-center'>
              <Col xs={12} className='mt-8'>{addServiceButton()}</Col>
            </Row>}

                
            {shouldShowAddServiceButton && (group?.type === LocalJobType.EXCHANGE1 || group?.type === LocalJobType.EXCHANGE2 || group?.type === LocalJobType.DISPOSAL || group?.type === LocalJobType.ON_THE_SPOT || group?.type === LocalJobType.TIPPER) &&<Row className='gx-12 align-items-center'>
              <Col xs={12} className='mt-8'>{getServiceList({ group: group, g: g })}</Col>
            </Row>}

          </Col>
        })}

      </Row>
    }
  }

  const addButton = (callback: () => void) => {
    return <Button 
      variant={'custom-secondary'}
      size={'sm'}
      disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        
        callback();
      }}
    >
      <PlusIcon /><span className='ps-s4'>Add Bin</span>
    </Button>
  }

  const addServiceButton = () => {
    return <Button 
      variant={'custom-secondary'}
      size={'sm'}
      disabled={checkStatus(values?.currentStatusName, ['cancelled', 'failed'])}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        
        // validateForm().then((err: any) => {
        //   if (err && Object.entries(err).length > 0) {
        //     warning('Warning', 'You must fill in the required fields');
        //   } else {
        //     let items = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings) : [];
        //     let newItem = _.cloneDeep(initPricingsItem);
        //     items.push(newItem);
            
        //     setFieldValue('pricings', items);
        //   }
        // })

        
        if(values.steps.some((x: any) => x.locationType === LocationEnum.CustomerSite)){
          let customerSite = getFirstCustomerSite(values);
          if(isNumeric(customerSite?.customerSiteId)){
            dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: customerSite?.customerSiteId, groupIndex: null, group: null, blockIndex: null, block: null, index: null, serviceItem: null, wasteTypes: [], isTask: false, isAdditional: true }));
          } else {
            warning('Warning', 'You must select a customer site');
          }
        } else {
          dispatch(servicesSlice.setShow({ show: true, values: values, customerSiteId: null, groupIndex: null, group: null, blockIndex: null, block: null, index: null, serviceItem: null, wasteTypes: [], isTask: false, isAdditional: true }));
        }
      }}
    >
      <PlusIcon /><span className='ps-s4'>Add Service</span>
    </Button>
  }


  return <Col xs={12} xxl={10}>
    <Spin indicator={<></>} spinning={(values.steps.some((x: any) => x.locationType === LocationEnum.CustomerSite)) ? !isAllCustomerSiteSelected(values.stepGroups) : false}>
      <Row className='g-16 align-items-center px-12'>
        <Col xs={12}>
          <span className="large semibold gray-900">{isTaskType(values?.steps) ? '4. Task Detail' : '4. Bin Detail'}</span>
        </Col>

        <Col xs={12}>{getBinElements()}</Col>

        <Col xs={12}>
          <Divider />
        </Col>
      </Row>
    </Spin>
  </Col>
}

export default BinDetails;
